<header class="topbar">
  <div class="topbar__inner">
    <a class="brand" routerLink="/library" (click)="closeMenu()">
      @if (branding.logoUrl && !logoFailed()) {
        <img class="brand__logo" [src]="branding.logoUrl" alt="" (error)="onLogoError()" />
      } @else {
        <span class="brand__mark" aria-hidden="true"></span>
      }
      <span class="brand__name">{{ branding.appName }}</span>
    </a>

    <button type="button" class="topbar__toggle" (click)="toggleMenu()"
            [attr.aria-expanded]="menuOpen()" aria-controls="primary-nav" aria-label="Menu">
      <span class="topbar__bars" aria-hidden="true"></span>
    </button>

    <nav class="nav" id="primary-nav" [class.is-open]="menuOpen()">
      <a routerLink="/library" routerLinkActive="is-active" (click)="closeMenu()">
        Library
        @if (selection.count() > 0) {
          <span class="pill">{{ selection.count() }}/2</span>
        }
      </a>
      <a routerLink="/compare" routerLinkActive="is-active" (click)="closeMenu()">Compare</a>
      <a routerLink="/results" routerLinkActive="is-active" (click)="closeMenu()">Past runs</a>
    </nav>

    <!-- Right-hand aside: what this build is, said quietly. Nothing to click. -->
    @if (branding.tagline) {
      <span class="topbar__status micro">
        <span class="topbar__dot" aria-hidden="true"></span>
        {{ branding.tagline }}
      </span>
    }
  </div>
</header>

<main class="content">
  <router-outlet />
</main>

<footer class="footer">
  <div class="footer__inner">
    <span class="brand brand--footer">
      @if (branding.logoUrl && !logoFailed()) {
        <img class="brand__logo" [src]="branding.logoUrl" alt="" />
      } @else {
        <span class="brand__mark" aria-hidden="true"></span>
      }
      <span class="brand__name">{{ branding.appName }}</span>
    </span>
  </div>
</footer>

<div class="toasts" role="status" aria-live="polite">
  @for (toast of notifications.toasts(); track toast.id) {
    <div class="toast" [class.toast--error]="toast.kind === 'error'"
         [class.toast--success]="toast.kind === 'success'"
         [class.toast--info]="toast.kind === 'info'">
      <span>{{ toast.message }}</span>
      <button type="button" class="toast__close" (click)="notifications.dismiss(toast.id)" aria-label="Dismiss">
        &times;
      </button>
    </div>
  }
</div>
